import classNames from "classnames"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { Panel } from "primereact/panel"
import { ProgressSpinner } from "primereact/progressspinner"
import { useEffect, useState } from "react"
import { FaCheck, FaExchangeAlt, FaTimes } from "react-icons/fa"
import { useInfo } from "../../../context/infoContext"
import { Api } from "../../../services/api"
import { formatCurrency } from "../../../utils/formatCurrency"
import AcceptPropostaDialog from "./acceptPropostaDialog"
import ContraPropostaDialog from "./contraPropostaDialog"
import { statusBodyTemplate } from "./propostaStatusBody"
import RejectPropostaDialog from "./rejectPropostaDialog"

function PropostasDialog({ infoPropostas, close, accept, reject }) {

  const { providerInfo } = useInfo()
  const [cobrancas, setCobrancas] = useState();
  const [valorOriginal, setValorOriginal] = useState(0);
  const [valorJuros, setValorJuros] = useState(0);
  const [valorMulta, setValorMulta] = useState(0);
  const [valorIndice, setValorIndice] = useState(0);
  const [valorCorrigido, setValorCorrigido] = useState(0);
  const [valorFeeProtesto, setValorFeeProtesto] = useState(0);
  const [valorTotal, setValorTotal] = useState(0);
  const [tipoFee, setTipoFee] = useState('');
  const [valorProposta, setValorProposta] = useState();
  const [valorTotalProposta, setValorTotalProposta] = useState(0)
  const [valorFeePagueProposta, setValorFeePagueProposta] = useState(0);
  const [valorFeeProtestoProposta, setValorFeeProtestoProposta] = useState(0);
  const [feeProporcional, setFeeProporcional] = useState(0)
  const [propostaTotal, setPropostaTotal] = useState();
  const [propostaParcelas, setPropostaParcelas] = useState();
  const [propostaValorEntrada, setPropostaValorEntrada] = useState();
  const [propostaJustificativa, setPropostaJustificativa] = useState();
  const [propostaStatus, setPropostaStatus] = useState();
  const [propostaData, setPropostaData] = useState();
  const [negotiateInfo, setNegotiateInfo] = useState([]);
  const [mostraConfirmacao, setMostraConfirmacao] = useState(false);
  const [inserirContraProposta, setInserirContraProposta] = useState(false)
  const [mostraContraProposta, setMostraContraProposta] = useState(false);
  const [mostraPropostaRejeita, setMostraPropostaRejeita] = useState(false)
  const [contraPropostaData, setContraPropostaData] = useState([])
  const [loading, setLoading] = useState(false);

  const footer = (
    <div className="flex justify-around w-full ">
      <Button
        label={mostraContraProposta ? "Enviar Contra-Proposta" : "Aceitar"}
        icon={<FaCheck className="mr-2" />}
        loading={loading}
        disabled={false}
        severity="info"
        onClick={() => { mostraContraProposta ? confirmarContraProposta() : confirmarNegociacao() }}
      />
      <Button
        label={"Contra-Proposta"}
        icon={<FaExchangeAlt className="mr-2" />}
        pt={{
          label: 'text-nowrap font-bold'
        }}
        loading={loading}
        disabled={mostraContraProposta || propostaStatus === "EM CONTRA PROPOSTA"}
        severity="success"
        onClick={() => { preparaContraProposta() }}
      />
      <Button
        label={mostraContraProposta ? "Limpar Contra-Proposta" : "Rejeitar"}
        icon={<FaTimes className="mr-2" />}
        loading={loading}
        //disabled={propostaStatus !== 'EM ANALISE' || propostaStatus !== "SOLICITADA"}
        severity="danger"
        onClick={() => { mostraContraProposta ? limpaContraProposta() : setMostraPropostaRejeita(true) }}
      />
    </div>
  )

  const dividaHeader = (
    <div className="mt-0">
      <h5><b>Valor da dívida:</b> </h5>
      <h5><b>{formatCurrency(valorTotal)} </b></h5>
    </div>
  )

  const dividaFooter = (
    <div className="m-2">
      <h5><b>Valor a Receber: </b></h5>
      <b><h5 className="text-xl text-green-600">
        {formatCurrency(
          (valorOriginal || 0) +
          (valorJuros || 0) +
          (valorMulta || 0) +
          (valorIndice || 0) + (providerInfo?.parametros?.pcc_info?.pcc_cobranca_fee === 'devedor' ? (+ 0) : (-(valorFeeProtesto || 0)))
        )}
      </h5></b>
    </div>

  )

  const propostaHeader = (
    <div className="mt-2">
      <h5><b>Valor Total da Proposta:</b> </h5>
      <h5><b>{formatCurrency(propostaTotal)}  </b> </h5>
    </div>
  )

  const contraPropostaHeader = (
    <div className="mt-2">
      <h5><b>Valor Proposta:</b> {formatCurrency(contraPropostaData.valorTotal)}  </h5>
    </div>
  )

  function confirmarNegociacao() {
    // console.log("CHEGO NO PROPOSTA: ", infoPropostas)
    const data = {
      cobrancas,
      proposta_id: infoPropostas.pnmt_id,
      acao: 'ACEITAR',
      valorTotal: valorTotal,
      desconto: valorTotal - valorProposta,
      valorAPagar: valorProposta,
      valorProtesto: valorFeeProtestoProposta,
      valorPague: valorFeePagueProposta,
      valorProvider: valorProposta - valorFeeProtestoProposta - valorFeePagueProposta,
      parcelas: propostaParcelas,
      fee_proporcional: feeProporcional,
      entrada: propostaValorEntrada,
      justificativa: '',
      mensagem_dialog: 'Confirme os dados da negociação a ser gerada',
      fee_plataforma: 2.9,
    }
    setNegotiateInfo(data)
    setMostraConfirmacao(true)
  }

  function confirmarContraProposta() {
    const data = {
      cobrancas,
      proposta_id: infoPropostas.pnmt_id,
      acao: 'CONTRA-PROPOSTA',
      valorTotal: valorTotal,
      desconto: valorTotal - contraPropostaData.valorTotal,
      valorAPagar: contraPropostaData.valorTotal,
      valorProtesto: contraPropostaData.valorFeeProtesto,
      valorPague: contraPropostaData.valorFeePague,
      valorProvider: contraPropostaData.valorProvider,
      parcelas: contraPropostaData.parcelas,
      fee_proporcional: feeProporcional,
      entrada: contraPropostaData.entrada,
      justificativa: contraPropostaData.mensagem,
      mensagem_dialog: 'Confirme os dados da contra-proposta',
      fee_plataforma: 2.9,
    }
    setNegotiateInfo(data)
    setMostraConfirmacao(true)
  }

  function preparaContraProposta() {
    const data = {
      valorTotal: valorTotal,
      desconto: valorTotal - valorProposta,
      valorAPagar: valorProposta,
      valorProtesto: valorFeeProtestoProposta,
      valorPague: valorFeePagueProposta,
      valorProvider: valorTotalProposta - valorFeeProtestoProposta,
      parcelas: propostaParcelas,
      fee_proporcional: feeProporcional,
      mensagem_dialog: 'Confirme os dados da contra-proposta',
      fee_plataforma: 2.9,
    }
    setNegotiateInfo(data)
    setInserirContraProposta(true)
  }

  function criaContraProposta(contra_proposta) {
    setContraPropostaData(contra_proposta)
    setMostraContraProposta(true)
  }

  function limpaContraProposta() {
    setContraPropostaData([])
    setMostraContraProposta(false)
  }

  function proporcionalFeeProtesto(valor_total, valor_fee, valor_proposta, parcela, entrada) {
    const fee_plataforma = 2.9
    const porcentagem_fee = valor_fee / valor_total
    if (entrada > 0) {
      const valor_restante = valor_proposta - entrada
      const valor_fee_pague_entrada = (((entrada) * 0.01) + fee_plataforma)
      const valor_fee_pague_restante = (((valor_restante / parcela) * 0.01) + fee_plataforma) * parcela
      const valor_fee_pague = valor_fee_pague_entrada + valor_fee_pague_restante
      const valor_fee_protesto = (valor_proposta - valor_fee_pague) * porcentagem_fee
      setValorTotalProposta(valor_proposta)
      setValorFeePagueProposta(valor_fee_pague)
      setValorFeeProtestoProposta(valor_fee_protesto)
    } else {
      const valor_fee_pague = (((valor_proposta / parcela) * 0.01) - fee_plataforma) * parcela
      const valor_fee_protesto = (valor_proposta - valor_fee_pague) * porcentagem_fee
      setValorTotalProposta(valor_proposta)
      setValorFeePagueProposta(valor_fee_pague)
      setValorFeeProtestoProposta(valor_fee_protesto)
    }
    console.table({ fee_plataforma, porcentagem_fee, valor_total, valor_proposta, valor_fee, entrada })
    setFeeProporcional(porcentagem_fee)
  }

  useEffect(() => {
    const getCobrancaData = async () => {
      try {
        setLoading(true)
        const { data } = await Api.get(`/propostas/listarDetalhes/${infoPropostas.pnmt_id}`)
        // console.log('Cobracas Vollto proposta:', data)
        //setTotal(data.count)
        setCobrancas(data.cobrancas)
        setValorOriginal(parseFloat(data.acumulado_propostas.valor_original))
        setValorJuros(parseFloat(data.acumulado_propostas.valor_juros))
        setValorMulta(parseFloat(data.acumulado_propostas.valor_multa))
        setValorIndice(0)
        setValorCorrigido(parseFloat(data.acumulado_propostas.valor_corrigido))
        setValorFeeProtesto(parseFloat(data.acumulado_propostas.valor_fee))
        setValorTotal(parseFloat(data.acumulado_propostas.valor_total))
        proporcionalFeeProtesto(parseFloat(data.acumulado_propostas.valor_total), parseFloat(data.acumulado_propostas.valor_fee), infoPropostas.pnmt_valor_proposta, infoPropostas.pnmt_valor_qtd_parcelas, infoPropostas.pnmt_valor_entrada)
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }

    function setPropostaInfo() {
      const valorCalculadoProposta = parseFloat(infoPropostas.pnmt_valor_proposta);
      setPropostaTotal(valorCalculadoProposta)
      setPropostaParcelas(infoPropostas.pnmt_valor_qtd_parcelas);
      setPropostaValorEntrada(infoPropostas.pnmt_valor_entrada);
      setValorProposta(infoPropostas.pnmt_valor_proposta);
      setPropostaJustificativa(infoPropostas.pnmt_justificativa);
      setPropostaStatus(infoPropostas.pnmt_situacao);
      setPropostaData(infoPropostas.pnmt_created_at);
    }

    getCobrancaData()
    setPropostaInfo()
  }, [])

  return (
    <Dialog
      header="Detalhes da Proposta"
      visible
      pt={{
        root: 'max-w-screen lg:max-h-[80vh]',
        headerTitle: 'font-bold text-xl w-full text-center',
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            //'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
      footer={footer}
      onHide={() => close()}
    >
      {mostraConfirmacao &&
        <AcceptPropostaDialog
          close={() => setMostraConfirmacao(false)}
          negotiateInfo={negotiateInfo}
          accept={() => { accept(negotiateInfo) }}
        />}
      {mostraPropostaRejeita && <RejectPropostaDialog
        close={() => setMostraPropostaRejeita(false)}
        reject={(e) => reject(e)}
      />}
      {inserirContraProposta &&
        <ContraPropostaDialog
          close={() => setInserirContraProposta(false)}
          negotiateInfo={negotiateInfo}
          accept={(contra_proposta) => { criaContraProposta(contra_proposta); setInserirContraProposta(false) }}
        />
      }
      {loading ?
        <ProgressSpinner strokeWidth="7" />
        :
        <div className="text-center grid">
          <h4 className="text-xl mb-2"><b>Confirme os detalhes das cobranças e da proposta</b></h4>
          <div className="flex gap-3">
            <div className="rounded-md border-2 dark:bg-emerald-900 bg-emerald-100">
              <h4 className="py-2 text-xl font-bold">Dívida Corrigida</h4>

              <Panel header={dividaHeader}
                pt={{
                  title: 'w-full text-center font-semibold'
                }}
                footer={dividaFooter}
              >
                <p><b>Detalhes</b></p>
                <h6><b>Valor Original:</b> <b className="text-green-500">(+)</b> {formatCurrency(valorOriginal)}</h6>
                {valorJuros > 0 && <h6><b>Valor Juros :</b> <b className="text-green-500">(+)</b> {formatCurrency(valorJuros)}</h6>}
                {valorMulta > 0 && <h6><b>Valor Multa:</b> <b className="text-green-500">(+)</b> {formatCurrency(valorMulta)}</h6>}
                {valorIndice > 0 && <h6><b>Valor Indice:</b> <b className="text-green-500">(+)</b> {formatCurrency(valorIndice)}</h6>}

                {providerInfo?.parametros?.pcc_info?.pcc_cobranca_fee === 'devedor' && (
                  <h6 className=""><b>Taxa paga pelo cliente:</b> <b className="text-green-500">(+)</b> {formatCurrency(valorFeeProtesto)}</h6>
                )}
                {valorFeeProtesto > 0 && <h6 className="border-t-2 mt-2"><b>Taxa de Serviços:</b> <b className="text-red-500">(-)</b> {formatCurrency(valorFeeProtesto)}</h6>}
              </Panel>
            </div>

            <div className="rounded-md border-2 dark:bg-sky-900 bg-sky-100">
              <h4 className="py-2 text-xl font-bold">Proposta Recebida</h4>
              <Panel header={propostaHeader}
                pt={{
                  title: 'w-full text-center font-semibold'
                }}
              >
                <h6><b>Nº de Parcelas:</b> {propostaValorEntrada > 0 && '1 +'} {propostaParcelas}</h6>
                {propostaValorEntrada > 0 && <h6><b>Valor Entrada:</b> {formatCurrency(propostaValorEntrada)}</h6>}
                <h6>
                  <b>Valor da Parcela:</b> {propostaParcelas} de {formatCurrency(
                    (parseFloat(valorProposta) - parseFloat(propostaValorEntrada)) / parseFloat(propostaParcelas)
                  )}
                </h6>
                <h6 className="border-t-2 mt-2"><b>Taxa de Serviços:</b> <b className="text-red-500">(-)</b> {formatCurrency(valorFeeProtestoProposta + valorFeePagueProposta)}</h6>
                <div className="dark:bg-sky-900 bg-sky-100">
                  <h5><b>Valor a Receber: </b></h5>
                  <h5><b className="text-xl text-green-600">
                    {formatCurrency(propostaTotal - valorFeePagueProposta - valorFeeProtestoProposta)}
                  </b></h5>
                </div>
                <h6 className=" mt-4"><b>Status:</b></h6>
                {statusBodyTemplate(infoPropostas)}
                <h6><b>Justificativa:</b></h6>
                <h6>{propostaJustificativa}</h6>
              </Panel>
            </div>
            {mostraContraProposta &&
              <div className="rounded-md border-2 dark:bg-rose-900 bg-rose-100">
                <h4 className="py-2 text-xl font-bold">Contra Proposta</h4>
                <Panel header={contraPropostaHeader} toggleable >
                  <h6><b>Nº de Parcelas:</b> {contraPropostaData.entrada > 0 && '1 + '}  {contraPropostaData.parcelas}</h6>
                  {contraPropostaData.entrada > 0 && <h6><b>Valor Entrada: </b>
                    {formatCurrency(contraPropostaData.entrada)}</h6>}
                  <h6><b>Justificativa:</b></h6>
                  <h6>{contraPropostaData.mensagem}</h6>
                </Panel>
              </div>
            }
          </div>
        </div>}
    </Dialog>
  )
}

export default PropostasDialog